export const FILE_IS_SAVING = 'FILE_IS_SAVING';
export const FILE_SAVE_SUCCESS = 'FILE_SAVE_SUCCESS';
export const FILE_SAVE_FAILED = 'FILE_SAVE_FAILED';